<mat-form-field appearance="outline" [ngClass]="allClasses">
    <mat-label>{{label}}</mat-label>
    <input matInput [matDatepicker]="picker" (dateChange)="selectedDate($event)"  [formControl]="control"  [min]="minDate"/>
    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker [disabled]="disabled"></mat-datepicker>
</mat-form-field>
